module.exports = __webpack_public_path__ + "img/ai-img-p2.617e1345.png";